// export default function auth({ next, nextMiddleware }) {
export default function auth({  nextMiddleware }) {
    //Если проверку не прошли то next('/');
    if (!window.keycloak.authenticated){
        window.keycloak.login(window.keycloakOptions)
    }
    // if (localStorage.getItem('accessToken') == null) {
    //     next({name: "LoginPage"})
    // }
    //Если ок, то nextMiddleware();
    return nextMiddleware();
}